import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Sidebar } from "semantic-ui-react";
import { AppSideBar } from "./AppBarMobile/AppBarMobile";
import Routes from "./Routes";
import { Toast } from "components/Toast/Toast";
import "react-toastify/dist/ReactToastify.min.css";
import LoadResolver from "./LoadResolver";
import { useSelector, useDispatch } from "react-redux";
import { getActiveUser } from "store/selectors";

const AppContent = () => {
  const sidebarIsVisible = useSelector((state) => state.ui.sidebarIsVisible);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch.activeUser.init();
  }, []);
  const authUser = useSelector(getActiveUser);
  return (
    <BrowserRouter>
      <Sidebar.Pushable>
        <AppSideBar />
        <Sidebar.Pusher dimmed={sidebarIsVisible} style={{ display: "flex" }}>
          <div className="breakpointer-hidden"></div>
          <div className="app-wrap">
            <LoadResolver isLoading={!authUser.item} hideWhenLoading>
              <Routes />
            </LoadResolver>
          </div>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
      <Toast />
    </BrowserRouter>
  );
};

export default AppContent;
